import React, { Component } from "react";

class FooterLinks extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="w-100">
          <div class="container container" style={{backgroundColor: '#6C6D6F'}}>
            <div className="text-left mt-4 w-100 pt-1 pb-1" style={{backgroundColor: '#6C6D6F'}}>
              <p className="text-light f-15 mb-0  pb-0">
                &copy; 2024 Dr Derma Southern Africa (PTY) LTD
              </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default FooterLinks;
